module.exports = __webpack_public_path__ + "static/bolt-depot-57081527f6a1e88adf3c31182f21fc9e.png";